import { render, staticRenderFns } from "./OtherRegions.vue?vue&type=template&id=7712af82&scoped=true&"
import script from "./OtherRegions.vue?vue&type=script&lang=js&"
export * from "./OtherRegions.vue?vue&type=script&lang=js&"
import style0 from "./OtherRegions.vue?vue&type=style&index=0&id=7712af82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7712af82",
  null
  
)

export default component.exports